// @flow

import { useState, useCallback, useRef } from 'react';
import styled from 'styled-components';

import ContentText from '../Text/ContentText';

import Checkbox from './Checkbox';

const Row = styled.a`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  min-height: 36px;
  padding-left: ${props => (props.withPadding ? '10px' : 0)};

  &:hover {
    background-color: ${props => props.theme.rowHoverColor};
  }
`;

const CheckboxWrapper = styled.div`
  margin-right: 8px;
  max-height: 16px;
  max-width: 16px;
  padding-top: 9px;
`;

const Text = styled(ContentText)`
  padding-top: 5px;
  padding-bottom: 5px;
  transition: opacity 0.5s ease;
`;

type Props = {
  initialValue: boolean,
  label: string,
  onToggle: (isSelected: boolean) => void,
  withPadding?: boolean,
  skipOpacityChange?: boolean
};

export default function LabeledCheckbox({
  initialValue,
  label,
  onToggle,
  withPadding = false,
  skipOpacityChange = false
}: Props) {
  const [isSelected, setIsSelected] = useState(initialValue);
  const checkboxRef = useRef();

  const toggle = useCallback(
    (selected: boolean) => {
      setIsSelected(selected);
      onToggle(selected);
    },
    [onToggle]
  );

  const getOpacity = () => {
    if (skipOpacityChange) {
      return 1;
    }
    return isSelected ? 0.65 : 1;
  };

  const onClick = () => {
    checkboxRef.current?.onClick();
  };

  return (
    <Row onClick={onClick} withPadding={withPadding}>
      <CheckboxWrapper>
        <Checkbox initialValue={initialValue} onToggle={toggle} ref={checkboxRef} />
      </CheckboxWrapper>
      <Text opacity={getOpacity()}>{label}</Text>
    </Row>
  );
}
